import { subscribeToPush, unsubscribeFromPush } from "~/apis/pushSubscriptions"

function urlBase64ToUint8Array(base64) {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4)
  const raw = atob((base64 + padding).replaceAll("-", "+").replaceAll("_", "/"))
  return Uint8Array.from([ ...raw ].map((char) => char.charCodeAt(0)))
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window
}

export async function currentPushSubscription() {
  if (!pushSupported()) return null

  const registration = await navigator.serviceWorker.ready
  return registration.pushManager.getSubscription()
}

export async function enablePush() {
  const vapidPublicKey = document.querySelector('meta[name="vapid-public-key"]')?.content
  if (!vapidPublicKey) throw new Error("Push notifications aren't configured yet.")

  await navigator.serviceWorker.register("/service-worker.js")
  // register() resolves as soon as the worker is installed, not once it's
  // active -- pushManager.subscribe needs an active worker, so wait for it.
  const registration = await navigator.serviceWorker.ready
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
  })

  await subscribeToPush(subscription)
  return subscription
}

export async function disablePush() {
  const subscription = await currentPushSubscription()
  if (!subscription) return

  await unsubscribeFromPush(subscription.endpoint)
  await subscription.unsubscribe()
}
